// Public links + registration schema shared across app
export const LOGO_URL = '/logo-tales.webp';
export const GOKU_ICON = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_linktree-clone-22/artifacts/qbgpzax3_GOKU-1.png';
export const KAMEN_ICON = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_linktree-clone-22/artifacts/zqjneokf_kamen-1.png';

// Deadline: 30 September 2026 23:59 WIB (UTC+7) -> 16:59 UTC
export const DEADLINE_UTC = '2026-09-30T16:59:00Z';

export const CATEGORIES_DISPLAY = [
  'Illustration',
  'Handcraft',
  'Experience',
  'Pop Culture',
  'TCG',
  'Trinket',
  'Merchandise',
  'Original / Fan Art',
];

export const CATEGORY_OPTIONS = [
  'Illustration',
  'Pop Culture',
  'Trinkets',
  'Handcraft',
  'Original / Fan Art',
  'Toys & Figures',
  'Trading Card Game (TCG)',
  'Merchandise',
  'Experience (Tarot Reading / Tattoo Art / etc)',
];

export const FLOORPLAN_URL = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_linktree-clone-22/artifacts/rqonb4e9_floorplan-1.png';

export const CORPORATE_INDUSTRIES = [
  'Toys & Collectibles',
  'Comics / Manga / Anime',
  'Trading Card Game (TCG)',
  'Fashion / Streetwear',
  'Food & Beverage',
  'Gaming / Esports',
  'Media / Entertainment',
  'Publishing / Studio',
  'Retail / E-commerce',
  'Tech / Apps',
  'Financial / Fintech',
  'Other',
];

export const FNB_TYPES = [
  'Makanan',
  'Minuman',
  'Makanan & Minuman',
  'Dessert / Bakery',
  'Coffee / Tea',
  'Snack / Jajanan',
];

// Corporate booth numbers = green booths on floorplan (M-series only)
export const CORPORATE_BOOTH_NUMBERS = Array.from({ length: 20 }, (_, i) => `M${i + 1}`);
export const CORPORATE_BOOTH_LAYOUT = [
  { row: ['M1', 'M2', 'M3', 'M4', null, 'M5', 'M6', 'M7', 'M8'] },
  { row: ['M9', 'M10', 'M11', 'M12', 'M13', 'M14'] },
  { row: ['M15', 'M16', 'M17', 'M18', 'M19', 'M20'] },
];

export const CORPORATE_BOOTH_INFO = {
  price: 'Rp 6.000.000',
  price_original: '',
  price_note: 'Brand Package',
  size: '300 × 200 cm',
  includes: [
    '1 Meja (120 × 60 cm)',
    'Listrik 4A',
    '2 Event ID & 2 Invitation Ticket',
    '1× Collab Post Feed IG @talesverse',
    'Indoor',
  ],
};

export const LINKS = [
  {
    id: 'creator-tenant-registration',
    label: 'CREATOR TENANT REGISTRATION',
    subtitle: 'Open Call',
    url: '/register',
    external: false,
    primary: true,
    iconType: 'image',
    iconSrc: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_linktree-clone-22/artifacts/qbgpzax3_GOKU-1.png',
  },
  {
    id: 'corporate-booth-registration',
    label: 'BRAND BOOTH REGISTRATION',
    subtitle: 'Booth premium untuk brand',
    url: '/corporate',
    external: false,
    primary: true,
    highlight: true,
    variant: 'dark',
    iconType: 'image',
    iconSrc: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_linktree-clone-22/artifacts/zqjneokf_kamen-1.png',
  },
  {
    id: 'fnb-registration',
    label: 'F&B REGISTRATION',
    subtitle: 'Food & Beverage tenant',
    url: '/fnb',
    external: false,
    primary: true,
  },
  {
    id: 'sales-sponsorship',
    label: 'Sales & Sponsorship',
    subtitle: 'WhatsApp: +62 857-7776-6625',
    url: 'https://wa.me/6285777766625',
    external: true,
    icon: 'whatsapp',
  },
  {
    id: 'partnership-media',
    label: 'Partnership & Media Partners',
    subtitle: 'WhatsApp: +62 852-1876-0805',
    url: 'https://wa.me/6285218760805',
    external: true,
    icon: 'whatsapp',
  },
  {
    id: 'proposal-creators',
    label: 'Proposal',
    subtitle: 'Google Drive folder',
    url: 'https://drive.google.com/drive/folders/1tSxoW3wpFcgWc6VRClUrzlhQ3NihvtXB?hl=ID',
    external: true,
    icon: 'drive',
  },
];

export const SOCIALS = [
  { id: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/talesverse' },
  { id: 'tiktok', label: 'TikTok', url: 'https://www.tiktok.com/@talesverseworld' },
];
